var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"card",attrs:{"title":"Agregar columna"}},[_c('div',[_c('formColumna')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }